/** Normalize Supabase / local space RPC errors into stable English messages. */
export function mapSpaceErrorMessage(message: string): string {
  const lower = message.toLowerCase();
  if (lower.includes('expired')) return 'Invite expired';
  if (lower.includes('already used')) return 'Invite already used';
  if (lower.includes('not found')) return 'Invite not found';
  if (lower.includes('full')) return 'Space is full';
  if (lower.includes('already in a space') || lower.includes('already a member')) {
    return 'Already in a space';
  }
  if (lower.includes('not a solo') || lower.includes('has plans') || lower.includes('has month focus')) {
    return 'Cannot leave a space that has a partner or plans';
  }
  if (lower.includes('not in a space')) return 'Not in a space';
  return message;
}

export type JoinErrorKind =
  | 'expired'
  | 'full'
  | 'already_in_space'
  | 'invalid'
  | 'cannot_leave'
  | 'generic';

export function classifyJoinError(message: string): JoinErrorKind {
  const lower = message.toLowerCase();
  if (lower.includes('expired')) return 'expired';
  if (lower.includes('full')) return 'full';
  if (lower.includes('already in a space') || lower.includes('already a member')) {
    return 'already_in_space';
  }
  if (lower.includes('cannot leave') || lower.includes('has plans') || lower.includes('partner')) {
    return 'cannot_leave';
  }
  if (
    lower.includes('not found') ||
    lower.includes('already used') ||
    lower.includes('invalid')
  ) {
    return 'invalid';
  }
  return 'generic';
}
